// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentDetailsDtoHoldingsInner } from './IInvestmentDetailsDtoHoldingsInner';
import {
    IInvestmentDetailsDtoHoldingsInnerFromJSON,
    IInvestmentDetailsDtoHoldingsInnerFromJSONTyped,
    IInvestmentDetailsDtoHoldingsInnerToJSON,
    IInvestmentDetailsDtoHoldingsInnerToJSONTyped,
} from './IInvestmentDetailsDtoHoldingsInner';

/**
 * 
 * @export
 * @interface IInvestmentDetailsDto
 */
export interface IInvestmentDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof IInvestmentDetailsDto
     */
    account_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentDetailsDto
     */
    investor_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IInvestmentDetailsDto
     */
    account_number?: string;
    /**
     * 
     * @type {Date}
     * @memberof IInvestmentDetailsDto
     */
    last_update_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvestmentDetailsDto
     */
    settled_portfolio_balance?: number;
    /**
     * 
     * @type {Array<IInvestmentDetailsDtoHoldingsInner>}
     * @memberof IInvestmentDetailsDto
     */
    holdings?: Array<IInvestmentDetailsDtoHoldingsInner>;
}

/**
 * Check if a given object implements the IInvestmentDetailsDto interface.
 */
export function instanceOfIInvestmentDetailsDto(value: object): value is IInvestmentDetailsDto {
    return true;
}

export function IInvestmentDetailsDtoFromJSON(json: any): IInvestmentDetailsDto {
    return IInvestmentDetailsDtoFromJSONTyped(json, false);
}

export function IInvestmentDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'investor_id': json['investor_id'] == null ? undefined : json['investor_id'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'last_update_at': json['last_update_at'] == null ? undefined : (new Date(json['last_update_at'])),
        'settled_portfolio_balance': json['settled_portfolio_balance'] == null ? undefined : json['settled_portfolio_balance'],
        'holdings': json['holdings'] == null ? undefined : ((json['holdings'] as Array<any>).map(IInvestmentDetailsDtoHoldingsInnerFromJSON)),
    };
}

export function IInvestmentDetailsDtoToJSON(json: any): IInvestmentDetailsDto {
    return IInvestmentDetailsDtoToJSONTyped(json, false);
}

export function IInvestmentDetailsDtoToJSONTyped(value?: IInvestmentDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_id': value['account_id'],
        'investor_id': value['investor_id'],
        'account_number': value['account_number'],
        'last_update_at': value['last_update_at'] == null ? undefined : ((value['last_update_at']).toISOString()),
        'settled_portfolio_balance': value['settled_portfolio_balance'],
        'holdings': value['holdings'] == null ? undefined : ((value['holdings'] as Array<any>).map(IInvestmentDetailsDtoHoldingsInnerToJSON)),
    };
}

